module.exports = __webpack_public_path__ + "static/media/BW_cartoon.d320a49e.jpg";